export const ROOT_URL = process.env.REACT_APP_HOST;

export * from "./actions-auth";
export * from "./actions-home";
